import get from 'lodash/get';
import keys from 'lodash/keys';

import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

import { SAMPLING_DISTRIBUTIONS_FORM } from '../names';

import { getCategoricalSummary } from 'store/dataset/summary';
import { getSelectedParameters } from 'store/dataset/parameters';

const selector = formValueSelector(SAMPLING_DISTRIBUTIONS_FORM);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getParameter = makeFieldValueGetter('parameter');
export const getParameterLevel = makeFieldValueGetter('parameterLevel');

export const getSampleSize = makeFieldValueGetter('sampleSize');
export const getNumberOfSamples = makeFieldValueGetter('numberOfSamples');

export const getAlpha = makeFieldValueGetter('alpha');
export const getTailType = makeFieldValueGetter('tailType');

export const getLeftCutoff = state => +selector(state, 'leftCutoff');
export const getRightCutoff = state => +selector(state, 'rightCutoff');

export const isParameterSelected = state => !!getParameter(state);
export const isParameterLevelSelected = state => !!getParameterLevel(state);

export const getParameterType = createSelector(
  getParameter,
  getSelectedParameters,

  (parameterName, selectedParameters) => {
    if (parameterName && selectedParameters) {
      return get(selectedParameters[parameterName], 'targetType');
    }

    return null;
  }
);

export const getParameterLevels = createSelector(
  getParameter,
  getParameterType,
  getCategoricalSummary,

  (parameterName, parameterType, summary) => {
    if (parameterType === 'categorical') {
      return keys(summary[parameterName].levels);
    }

    return null;
  }
);
